import React, { useEffect, useRef, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService'
import { getAccesosWebUser, updateEstadoAccesoWeb } from '../../../API/IT/Accesos/AccesosRequests';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import Icon from '../../../Base/Components/Icon/Icon';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import AccesosUsersCrud from './AccesosCrud/AccesosCrud';
import AccesosUser from './AccesosUser'

const AccesosScreen = () => {


    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const [Accesos, setAccesos] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [showDialogUser, setShowDialogUser] = useState(false);



    const getInfo = async () => {
        setLoading(true);
        const d = await getAccesosWebUser();
        console.log(d);
        setAccesos(d);
        setLoading(false);
    };

    const Botones = ({rowData}) => {
        return (
            <div className='col-12 d-flex' style={{ textAlign: 'center', height: 28, marginTop: -6 }}>
                <Button
                    icon='pi pi-pencil'
                    className='p-button-rounded  p-button-infop p-button-text'
                    onClick={e => {
                        setShowDialog(true);
                        setSelected(rowData);
                    }}
                />

                <Button
                    icon='pi ri-tools-fill'
                    className='p-button-rounded  p-button-infop p-button-text'
                    onClick={e => {
                        setShowDialogUser(true);
                        setSelected(rowData);
                    }}
                />
            </div>
            

        )
    }

    const onChangeCheck = async (acceso, IdAcceso, activo) => {
        const t = await updateEstadoAccesoWeb({
            Acceso: acceso,
            Activo: activo,
            IdAcceso: IdAcceso
        })
        setAccesos(t);
    }

    const columns = [
        {
            field: 'IdAcceso',
            header: 'IdAcceso',
            className: 'colum-width-Xsmall',
        },
        {
            field: 'Acceso',
            header: 'Acceso',
            className: 'colum-width-Xlarge',
        },
        {
            field: 'Activo Web',
            header: 'ActivoWeb',
            className: 'colum-width-small',
            Format: "Template",
            align: "center",
            body: (rowData) => rowData?.IdAcceso && <Checkbox onChange={(e) => onChangeCheck(1, rowData.IdAcceso, e.checked)} style={{ marginBottom: 5 }} checked={rowData.ActivoWeb} />
        },
        {
            field: 'Activo App',
            header: 'ActivoApp',
            className: 'colum-width-small',
            Format: "Template",
            align: "center",
            body: (rowData) => rowData?.IdAcceso && <Checkbox onChange={(e) => onChangeCheck(2, rowData.IdAcceso, e.checked)} style={{ marginBottom: 5 }} checked={rowData.ActivoApp} />
        },
        {
            header: 'Id Menu',
            field: 'IdMenu',
            className: 'colum-width-large',
        },
        {
            field: 'Menu',
            header: 'Menu',
            className: 'colum-width-medium',
        },
        {
            field: 'Icon',
            header: 'Icon',
            className: 'colum-width-medium',
            body: (rowData) => <Icon icon={rowData.Icon ? rowData.Icon : 'a'} />,
            align: 'center',
            Format: 'Icon'
        },
        {
            field: 'URL',
            header: 'URL',
            className: 'colum-width-medium',
        },
        {
            header: 'Acciones',
            className: 'colum-width-small',
            Format: "Template",
            body: (rowData) => rowData?.IdAcceso && <Botones rowData={rowData} />,
        }

    ]

    const table = {
        Columns: columns,
        Data: Accesos,
        loading: loading
    };

    useEffect(() => {
        setTitlePage('Accesos');
        getInfo();
    }, [])


    return (
        <div>
            <Toast ref={toast} />
            <Card
                titulo={<div className='botones'>
                    <h3>Accesos</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                    <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
                </div>}
                contenido={<div className='p-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />

            {showDialog && <AccesosUsersCrud toast={toast} accesosDialog={showDialog} datos={selected} setAccesosDialog={setShowDialog} getAccesos={getInfo} />}


            {showDialogUser && <AccesosUser toast={toast} showDialogUser={showDialogUser} selected={selected} setShowDialogUser={setShowDialogUser} getAccesos={getInfo} />}

        </div>
    )
}

export default AccesosScreen